

import React, { useRef, useState } from "react";
import { Tag, Typography, Input, Button, Tabs, Table, Modal, Checkbox, Upload } from "antd";
import { SearchOutlined, EyeInvisibleOutlined, CloseOutlined, CloudUploadOutlined, InfoCircleOutlined } from "@ant-design/icons";
//import './Reports.scss';
import PrimaryNav from "../../shared/PrimaryNav";
import PageHeader from "../../shared/PageHeader";
import AgTableClient from "../../shared/AgTable/AgTableClient";
import './index.scss';
import { Segmented } from "antd";
import Cleartrip from "../../assets/images/Cleartrip.jpg";
import { useNavigate } from "react-router-dom";


function HotelSalesBoost() {
    const ref = useRef(null);
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("my data");
    const [isPromoteModalOpen, setIsPromoteModalOpen] = useState(false);
    const [selectedClients, setSelectedClients] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const items = [
        {
            key: "1",
            label: "Recon A",
        },
        {
            key: "2",
            label: "Recon B",
        },
    ];

    const cardsData = [
        {
            title: "Vendor Ranking",
            value: "18",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.875 7.49993C16.8757 6.34134 16.5836 5.20136 16.0258 4.18589C15.468 3.17041 14.6626 2.31237 13.6844 1.69147C12.7062 1.07057 11.587 0.706936 10.4307 0.634355C9.27438 0.561774 8.11847 0.782595 7.07034 1.27631C6.02221 1.77002 5.11584 2.52062 4.43544 3.45837C3.75503 4.39612 3.32265 5.49062 3.17846 6.64021C3.03426 7.78979 3.18293 8.95717 3.61065 10.0339C4.03837 11.1107 4.73128 12.0619 5.625 12.7992V18.7499C5.62492 18.8565 5.65211 18.9614 5.70397 19.0545C5.75584 19.1476 5.83065 19.2259 5.92131 19.282C6.01197 19.338 6.11546 19.37 6.22195 19.3748C6.32843 19.3795 6.43437 19.357 6.52969 19.3093L10 17.5781L13.4711 19.3132C13.5581 19.3549 13.6535 19.376 13.75 19.3749C13.9158 19.3749 14.0747 19.3091 14.1919 19.1919C14.3092 19.0747 14.375 18.9157 14.375 18.7499V12.7992C15.157 12.1551 15.7867 11.3459 16.2189 10.4297C16.6512 9.51352 16.8752 8.51298 16.875 7.49993ZM4.375 7.49993C4.375 6.38741 4.7049 5.29988 5.32298 4.37485C5.94107 3.44982 6.81957 2.72885 7.84741 2.30311C8.87524 1.87737 10.0062 1.76597 11.0974 1.98301C12.1885 2.20006 13.1908 2.73579 13.9775 3.52246C14.7641 4.30913 15.2999 5.31141 15.5169 6.40255C15.734 7.49369 15.6226 8.62469 15.1968 9.65253C14.7711 10.6804 14.0501 11.5589 13.1251 12.1769C12.2001 12.795 11.1125 13.1249 10 13.1249C8.50867 13.1233 7.07889 12.5301 6.02435 11.4756C4.96982 10.421 4.37666 8.99127 4.375 7.49993ZM5.625 7.49993C5.625 6.63464 5.88159 5.78878 6.36232 5.06931C6.84305 4.34985 7.52633 3.78909 8.32576 3.45796C9.12519 3.12683 10.0049 3.04019 10.8535 3.209C11.7022 3.37781 12.4817 3.79449 13.0936 4.40634C13.7054 5.01819 14.1221 5.79775 14.2909 6.64641C14.4597 7.49508 14.3731 8.37475 14.042 9.17417C13.7108 9.9736 13.1501 10.6569 12.4306 11.1376C11.7112 11.6183 10.8653 11.8749 10 11.8749C8.84006 11.8737 7.72798 11.4124 6.90778 10.5922C6.08758 9.77195 5.62624 8.65987 5.625 7.49993Z" fill="#F0B100"/>
                </svg>
            )
        },
        {
            title: "Your Compliance Score",
            value: "88%",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 2L3 5V9C3 13.55 6.27 17.5 10 18.5C13.73 17.5 17 13.55 17 9V5L10 2Z" fill="#10B981" />
                    <path d="M8.5 11.5L6.5 9.5L5.5 10.5L8.5 13.5L14.5 7.5L13.5 6.5L8.5 11.5Z" fill="white" />
                </svg>
            )
        },
        {
            title: "Vicinity Average",
            value: "82%",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 2V6.5C10 6.89782 10.158 7.27936 10.4393 7.56066C10.7206 7.84196 11.1022 8 11.5 8H16V16.5C16 16.8978 15.842 17.2794 15.5607 17.5607C15.2794 17.842 14.8978 18 14.5 18H9.743C10.4899 17.0956 10.928 15.976 10.9935 14.8049C11.059 13.6338 10.7483 12.4724 10.1069 11.4903C9.46551 10.5083 8.52694 9.75702 7.42827 9.34623C6.32959 8.93544 5.12837 8.88666 4 9.207V3.5C4 3.10218 4.15804 2.72064 4.43934 2.43934C4.72064 2.15804 5.10218 2 5.5 2H10ZM11 2.25V6.5C11 6.63261 11.0527 6.75979 11.1464 6.85355C11.2402 6.94732 11.3674 7 11.5 7H15.75L11 2.25ZM10 14.5C10 15.6935 9.52589 16.8381 8.68198 17.682C7.83807 18.5259 6.69347 19 5.5 19C4.30653 19 3.16193 18.5259 2.31802 17.682C1.47411 16.8381 1 15.6935 1 14.5C1 13.3065 1.47411 12.1619 2.31802 11.318C3.16193 10.4741 4.30653 10 5.5 10C6.69347 10 7.83807 10.4741 8.68198 11.318C9.52589 12.1619 10 13.3065 10 14.5ZM5.5 12C5.36739 12 5.24021 12.0527 5.14645 12.1464C5.05268 12.2402 5 12.3674 5 12.5V14.5C5 14.6326 5.05268 14.7598 5.14645 14.8536C5.24021 14.9473 5.36739 15 5.5 15C5.63261 15 5.75979 14.9473 5.85355 14.8536C5.94732 14.7598 6 14.6326 6 14.5V12.5C6 12.3674 5.94732 12.2402 5.85355 12.1464C5.75979 12.0527 5.63261 12 5.5 12ZM5.5 17.125C5.66576 17.125 5.82473 17.0592 5.94194 16.9419C6.05915 16.8247 6.125 16.6658 6.125 16.5C6.125 16.3342 6.05915 16.1753 5.94194 16.0581C5.82473 15.9408 5.66576 15.875 5.5 15.875C5.33424 15.875 5.17527 15.9408 5.05806 16.0581C4.94085 16.1753 4.875 16.3342 4.875 16.5C4.875 16.6658 4.94085 16.8247 5.05806 16.9419C5.17527 17.0592 5.33424 17.125 5.5 17.125Z" fill="#046666"/>
                </svg>
            )
        }
    ];

    const hotelsData = [
        {
            key: '1',
            rank: 1,
            hotelName: 'The Oberoi',
            complianceScore: '93%'
        },
        {
            key: '2',
            rank: 2,
            hotelName: 'The Taj Mahal Palace',
            complianceScore: '92%'
        },
        {
            key: '3',
            rank: 3,
            hotelName: 'The Leela Palace',
            complianceScore: '92%'
        },
        {
            key: '4',
            rank: 4,
            hotelName: 'ITC Maurya',
            complianceScore: '91%'
        },
        {
            key: '5',
            rank: 5,
            hotelName: 'Umaid Bhawan',
            complianceScore: '91%'
        }
    ];

    // Hotel icon mapping - add hotel icons here
    const hotelIcons = {
        'The Oberoi': 'https://static-assets.finkraftai.com/logo/oberoi.png',
        // Add more hotel icons as needed
    };

    const renderHotelName = (text) => {
        const hasIcon = hotelIcons[text];
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {hasIcon ? (
                    <img 
                        src={hotelIcons[text]} 
                        alt={text}
                        className="hotel-icon"
                        onError={(e) => {
                            // Fallback to generic icon if image fails to load
                            e.target.style.display = 'none';
                            const fallback = e.target.parentElement.querySelector('.name-icon');
                            if (fallback) fallback.style.display = 'block';
                        }}
                    />
                ) : (
                    <div className="name-icon"></div>
                )}
                <span>{text}</span>
            </div>
        );
    };

    const hotelsColumns = [
        {
            title: 'Rank',
            dataIndex: 'rank',
            key: 'rank',
            width: 80,
        },
        {
            title: 'Hotel name',
            dataIndex: 'hotelName',
            key: 'hotelName',
            render: renderHotelName,
        },
        {
            title: 'Compliance Score',
            dataIndex: 'complianceScore',
            key: 'complianceScore',
            align: 'right',
        },
    ];

    const clientsData = [
        {
            key: '1',
            client: 'Deloitte',
            promoted: 'Yes',
            status: 'Active'
        },
        {
            key: '2',
            client: 'KPMG',
            promoted: 'Yes',
            status: 'Active'
        },
        {
            key: '3',
            client: 'PWC',
            promoted: 'No',
            status: 'Pending'
        },
        {
            key: '4',
            client: 'EY',
            promoted: 'No',
            status: 'Pending'
        },
        {
            key: '5',
            client: 'BCG',
            promoted: 'Yes',
            status: 'Active'
        }
    ];

    const renderClientName = (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div className="name-icon"></div>
            <span>{text}</span>
        </div>
    );

    const renderPromoted = (text) => (
        <span style={{ color: text === 'Yes' ? '#10B981' : '#EF4444' }}>
            {text}
        </span>
    );

    const renderStatus = (text) => (
        <Button
            className={`status-badge ${text === 'Active' ? 'status-active' : 'status-pending'}`}
            size="small"
            style={{
                border: 'none',
                borderRadius: '4px',
                height: 'auto',
                padding: '4px 12px',
                fontSize: '13px',
                fontWeight: 500,
                fontFamily: 'Noto Sans',
                cursor: 'default',
                pointerEvents: 'none'
            }}
        >
            {text}
        </Button>
    );

    const clientsColumns = [
        {
            title: 'Client',
            dataIndex: 'client',
            key: 'client',
            render: renderClientName,
        },
        {
            title: 'Promoted',
            dataIndex: 'promoted',
            key: 'promoted',
            render: renderPromoted,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: renderStatus,
        },
    ];

    const clientsList = [
        { id: 1, name: 'Tata Group' },
        { id: 2, name: 'Reliance Industries' },
        { id: 3, name: 'HDFC Bank' },
        { id: 4, name: 'Infosys' },
        { id: 5, name: 'ICICI Bank' },
        { id: 6, name: 'State Bank of India' },
    ];

    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
             <PageHeader
                            style={{ height: '60px' }}
                            leftActions={
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <rect width="40" height="40" rx="4" fill="#8C734C" />
                                        <path d="M29.9499 9.07643L30.9575 8.47134V5L27.0215 7.32484M30.5796 6.17834V8.34395L29.6665 6.71975L30.5796 6.17834ZM30.0443 8.66242L28.218 7.57962L29.1312 7.03822L30.0443 8.66242Z" fill="white" />
                                        <path d="M29.6354 9.61818L26.707 7.89844V12.58L29.6354 10.8602M27.4942 8.822L29.3205 9.90481H27.4942V8.822ZM27.4942 11.6246V10.5417H29.3205L27.4942 11.6246Z" fill="white" />
                                        <path d="M31.5879 11.9742V15.4456L35.5554 13.1207L32.627 11.3691M31.9972 14.2672V12.1016L32.9104 13.7258L31.9972 14.2672ZM33.4457 13.4074L32.5325 11.7832L34.3588 12.866L33.4457 13.4074Z" fill="white" />
                                        <path d="M32.9414 9.61818V10.8284L35.8698 12.5481V7.89844M35.0511 11.6246L33.2248 10.5417H35.0511V11.6246ZM35.0511 9.90481H33.2248L35.0511 8.822V9.90481Z" fill="white" />
                                        <path d="M35.5554 7.32484L31.5879 5V8.47134L32.5955 9.07643M31.9972 6.17834L32.9104 6.71975L31.9972 8.34395V6.17834ZM33.4457 7.03822L34.3588 7.57962L32.5325 8.66242L33.4457 7.03822Z" fill="white" />
                                        <path d="M27.0215 13.1207L30.989 15.4456V11.9742L29.9499 11.3691M30.5796 14.2672L29.6665 13.7258L30.5796 12.1016V14.2672ZM29.1312 13.4074L28.218 12.866L30.0443 11.7832L29.1312 13.4074Z" fill="white" />
                                        <path d="M9.19943 24.9683C9.19943 26.6244 9.19943 28.0575 9.10497 28.8218C9.04199 29.3314 8.94753 29.7454 8.56968 29.8091C8.41224 29.8409 8.19182 29.8728 7.93992 29.8728C7.7195 29.8728 7.65653 29.9365 7.65653 30.032C7.65653 30.1594 7.78248 30.2231 8.00289 30.2231C8.72712 30.2231 9.86068 30.1594 10.27 30.1594C10.7738 30.1594 11.9074 30.2231 13.1039 30.2231C13.2929 30.2231 13.4503 30.1594 13.4503 30.032C13.4503 29.9365 13.3558 29.8728 13.1669 29.8728C12.8835 29.8728 12.5057 29.8409 12.2538 29.8091C11.7185 29.7454 11.624 29.3314 11.561 28.8218C11.4666 28.0256 11.4666 26.6244 11.4666 24.9365V17.5161L13.7337 17.5798C15.3396 17.6116 15.8119 18.1212 15.8434 18.5989L15.8749 18.79C15.9064 19.0766 15.9378 19.1403 16.0638 19.1403C16.1583 19.1403 16.2212 19.0447 16.2212 18.8537C16.2212 18.3759 16.2842 17.1339 16.2842 16.7517C16.2842 16.4651 16.2527 16.3696 16.1268 16.3696C15.9693 16.3696 15.56 16.5607 14.3949 16.5607H7.27867C6.6804 16.5607 6.01916 16.5288 5.48386 16.4651C5.04303 16.4333 4.8541 16.2422 4.69666 16.2422C4.6022 16.2422 4.53923 16.3377 4.47625 16.5925C4.47625 16.7517 4.12988 18.4078 4.12988 18.6944C4.12988 18.8855 4.16137 18.981 4.28732 18.981C4.38179 18.981 4.44476 18.9173 4.47625 18.7581C4.50774 18.5989 4.6022 18.4078 4.79113 18.1212C5.07452 17.739 5.48386 17.6435 6.52296 17.6116L9.19943 17.5479" fill="white" />
                                        <path d="M22.8032 25.5092L22.9607 25.6366L24.3776 29.4901C24.4721 29.713 24.3461 29.8722 24.2202 29.9041C24.0313 29.9359 23.9683 29.9678 23.9683 30.0633C23.9683 30.1907 24.1887 30.1907 24.5036 30.2225C25.9205 30.2544 27.18 30.2544 27.8098 30.2544C28.471 30.2544 28.6285 30.2225 28.6285 30.0633C28.6285 29.9359 28.534 29.9041 28.4081 29.9041C28.1877 29.9041 27.9358 29.8722 27.6838 29.8404C27.306 29.7448 26.8022 29.4901 26.1409 27.8659C25.0074 25.0951 22.205 17.7066 21.7956 16.6875C21.6067 16.2735 21.5122 16.1143 21.3548 16.1143C21.1659 16.1143 21.0714 16.3053 20.851 16.8467L16.4427 28.248C16.0963 29.1716 15.7499 29.7767 14.9627 29.8722C14.8368 29.9041 14.5849 29.9041 14.4274 29.9041C14.3015 29.9041 14.207 29.9359 14.207 30.0633C14.207 30.2225 14.3015 30.2544 14.5534 30.2544C15.4665 30.2544 16.4427 30.1907 16.6316 30.1907C17.1669 30.1907 17.9226 30.2544 18.4894 30.2544C18.6783 30.2544 18.7728 30.2225 18.7728 30.0633C18.7728 29.9678 18.7098 29.9041 18.5209 29.9041H18.269C17.7337 29.9041 17.5762 29.6811 17.5762 29.3308C17.5762 29.1079 17.6707 28.6939 17.8281 28.2162L18.7728 25.6047C18.8043 25.5092 18.8358 25.4455 18.9302 25.4455M19.2451 24.5856L19.1821 24.4582L20.788 19.9996L20.8825 19.8404L20.9769 19.9996L22.5513 24.4901L22.4569 24.5856H19.2451Z" fill="white" />
                                        <path d="M30.4221 27.0701C30.4221 30.637 30.4536 32.4523 29.1311 33.8536C28.7847 34.2039 28.5328 34.4268 28.3124 34.5542C28.029 34.7134 27.9346 34.7771 27.9346 34.8727L28.0605 35.0319C28.155 35.0319 28.2809 35 28.4069 34.9364C28.7533 34.7453 29.0366 34.6179 29.2571 34.4586C30.8944 33.3758 31.8076 32.1338 32.1854 31.0192C32.5318 30 32.5948 28.8217 32.5948 27.8026C32.5948 26.9109 32.5318 26.0192 32.5318 25.2548V21.8472C32.5318 19.0765 32.5318 18.5669 32.5633 17.9937C32.5948 17.3567 32.7207 17.0383 33.193 16.9746C33.4135 16.9427 33.5079 16.9109 33.6969 16.9109C33.9173 16.9109 34.0117 16.879 34.0117 16.7516C34.0117 16.6243 33.8858 16.5924 33.6339 16.5924C32.9726 16.5924 31.8706 16.6561 31.4612 16.6561C31.0204 16.6561 29.9183 16.5924 29.0366 16.5924C28.7847 16.5924 28.6588 16.6243 28.6588 16.7516C28.6588 16.879 28.7533 16.9109 28.9422 16.9109C29.1941 16.9109 29.4775 16.9427 29.6034 16.9746C30.1702 17.102 30.2962 17.3886 30.3276 17.9937C30.3591 18.5669 30.3591 19.0765 30.3591 21.8472" fill="white" />
                                    </svg>
                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '4px' }}>
                                        <span style={{ color: "#161922", fontSize: '16px' }}>Taj Hotel</span>
                                        <span style={{ color: "#7D7D82", fontSize: '12px' }}>1245 Grand Avenue, Ojai, CA</span>
                                    </div>
                                </div>
                            }
                        />
            <div className="header-section">
                <div className="header-content">
                    <Typography className="heading-text">Sales Boost</Typography>
                    <span className="subheading-text">Promote your property to Finkraft's client network</span>
                </div>
                <div className="my-segmented" style={{ display: "flex", gap: "8px" }}>
                    <Button
                        style={{
                           color:'#0a8394',
                           borderColor:"#0a8394" ,
                           backgroundColor:'white'
                        }}
                        onClick={() => navigate('/hotel-booking-hotel?filter=Pending')}
                    >
                   Improve Compliance
                    </Button>

                    <Button
                         style={{
                           color:'white',
                           borderColor:"#0a8394" ,
                           backgroundColor:'#0a8394'
                        }}
                        onClick={() => setIsPromoteModalOpen(true)}
                    >
                      Promote
                    </Button>
                </div>

            </div>

            <div className="detail-section">
                {cardsData.map((item, index) => (
                    <div className="detail-card" key={index}>
                        <div className="card-content1">
                            <div className="card-header">
                                <div
                                    className={
                                        index === 0
                                            ? "card-icon"
                                            : index === 1
                                                ? "card-icon1"
                                                : "card-icon2"
                                    }
                                >
                                    {item.icon}
                                </div>
                                <span className="card-title">{item.title}</span>
                            </div>
                            <span className="card-value">{item.value}</span>
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ display: "flex", gap: "24px",marginLeft: "20px",marginRight: "20px",marginTop: "24px" }}>
                <div className="table-section">
                      <div style={{display: "flex", flexDirection: "column", gap: "4px", marginBottom: "16px"}}>
                        <span className="table-title">Hotels Near You</span>
                        <span className="table-subtitle">Here's what you need to focus on today</span>
                      </div>
                      <Table
                          columns={hotelsColumns}
                          dataSource={hotelsData}
                          pagination={false}
                          className="hotels-table"
                          size="middle"
                          bordered={false}
                          showHeader={true}
                      />
                </div>
                <div className="table-section">
                      <div style={{display: "flex", flexDirection: "column", gap: "4px", marginBottom: "16px"}}>
                        <span className="table-title">Potential Clients Booking Other Properties</span>
                        <span className="table-subtitle">Here's what you need to focus on today</span>
                      </div>
                      <Table
                          columns={clientsColumns}
                          dataSource={clientsData}
                          pagination={false}
                          className="clients-table"
                          size="middle"
                          bordered={false}
                          showHeader={true}
                      />
               </div>
            </div>

            <Modal
                open={isPromoteModalOpen}
                onCancel={() => setIsPromoteModalOpen(false)}
                footer={null}
                width={900}
                className="promote-modal"
                closable={false}
            >
                <div className="promote-modal-content">
                    {/* Header */}
                    <div className="promote-modal-header">
                        <Typography className="promote-modal-title">Promote</Typography>
                        <CloseOutlined 
                            className="promote-modal-close" 
                            onClick={() => setIsPromoteModalOpen(false)}
                        />
                    </div>

                    {/* Body */}
                    <div className="promote-modal-body">
                        {/* Left Section - Clients */}
                        <div className="promote-modal-left">
                            <div className="promote-clients-header">
                                <Typography className="promote-clients-title">Clients</Typography>
                                <Checkbox
                                    checked={selectAll}
                                    onChange={(e) => {
                                        setSelectAll(e.target.checked);
                                        if (e.target.checked) {
                                            setSelectedClients(clientsList.map(c => c.id));
                                        } else {
                                            setSelectedClients([]);
                                        }
                                    }}
                                >
                                    Select all
                                </Checkbox>
                            </div>
                            <div className="promote-clients-list">
                                {clientsList.map((client) => (
                                    <Checkbox
                                        key={client.id}
                                        checked={selectedClients.includes(client.id)}
                                        onChange={(e) => {
                                            let newSelected;
                                            if (e.target.checked) {
                                                newSelected = [...selectedClients, client.id];
                                            } else {
                                                newSelected = selectedClients.filter(id => id !== client.id);
                                                setSelectAll(false);
                                            }
                                            setSelectedClients(newSelected);
                                            // Update select all if all clients are selected
                                            if (newSelected.length === clientsList.length) {
                                                setSelectAll(true);
                                            }
                                        }}
                                    >
                                        {client.name}
                                    </Checkbox>
                                ))}
                            </div>
                        </div>

                        {/* Right Section - Promotion Details */}
                        <div className="promote-modal-right">
                            {/* Compliance Score */}
                            <div className="promote-section promote-compliance-section">
                                <div className="promote-compliance-header">
                                    <div>
                                        <Typography className="promote-label">Your Compliance Score</Typography>
                                        <Typography className="promote-score-note">
                                            This will be highlighted in<br/> your promotional message
                                        </Typography>
                                    </div>
                                    <Typography className="promote-score-value">88%</Typography>
                                </div>
                                <div className="promote-section promote-attachments-section">
                                <div className="promote-label-with-icon">
                                    <Typography className="promote-label">Attachments</Typography>
                                    <InfoCircleOutlined className="promote-info-icon" />
                                </div>
                                <Upload>
                                    <Button 
                                        icon={<CloudUploadOutlined />} 
                                        className="promote-upload-btn"
                                    >
                                        Upload
                                    </Button>
                                </Upload>
                            </div>
                            </div>

                            {/* Attachments */}
                           

                            {/* Subject */}
                            <div className="promote-section">
                                <Typography className="promote-label">Subject</Typography>
                                <Input placeholder="Choose a category" />
                            </div>

                            {/* Body */}
                            <div className="promote-section">
                                <Typography className="promote-label">Body</Typography>
                                <Input.TextArea 
                                    placeholder="Choose a category" 
                                    rows={4}
                                />
                            </div>

                            {/* Contact Information */}
                            <div className="promote-section">
                                <Typography className="promote-label">Contact Information</Typography>
                                <Input placeholder="Name" style={{ marginBottom: '12px' }} />
                                <div className="promote-contact-row">
                                    <Input placeholder="Email" style={{ flex: 1 }} />
                                    <Input placeholder="Phone" style={{ flex: 1, marginLeft: '12px' }} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="promote-modal-footer">
                        <Button 
                            onClick={() => setIsPromoteModalOpen(false)}
                            className="promote-cancel-btn"
                        >
                            Cancel
                        </Button>
                        <Button 
                            type="primary"
                            className="promote-send-btn"
                        >
                            Send Promotion
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default HotelSalesBoost;

